import(/* webpackMode: "eager" */ "/app/apps/web/app/(public)/legal/terms/page.tsx");
